// extracted by mini-css-extract-plugin
export default {"bigHeaderInfoBlock":"BigHeaderInfoBlock_bigHeaderInfoBlock__XEuwA"};